import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
    IonCard,
} from '@ionic/react';
import Footer from './Footer';
import Header from './Header';

const ContactUs: React.FC = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phonenumber: '', feedback: '' });
    const [showToast, setShowToast] = useState(false);

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.detail.value });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const response = await fetch('https://mamasguidance.com/contactus.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        });
        const data = await response.json();
        console.log('Server response:', data);
        if (response.ok) {
            setShowToast(true);
            setFormData({ name: '', email: '', phonenumber: '', feedback: '' });
        } else {
            console.error('Server returned error:', data);
        }
    };

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>Contact Us</h1>
                <form onSubmit={handleSubmit}>
                    <div className='mb-3'>
                        <IonLabel position="floating">Name</IonLabel>
                        <IonInput placeholder='Optional' name="name" value={formData.name} onIonChange={handleChange} />
                    </div>
                    <div className='mb-3'>
                        <IonLabel position="floating">Email</IonLabel>
                        <IonInput placeholder='Optional' type="email" name="email" value={formData.email} onIonChange={handleChange} />
                    </div>
                    <div className='mb-3'>
                        <IonLabel position="floating">Phone Number</IonLabel>
                        <IonInput placeholder='Optional' type="text" name="phonenumber" value={formData.phonenumber} onIonChange={handleChange} />
                    </div>
                    <div className='mb-3'>
                        <IonLabel position="floating">Feedback <span style={{ color: "red" }}>*</span></IonLabel>
                        <IonTextarea placeholder='Type your feedback here' name="feedback" value={formData.feedback} onIonChange={handleChange} required />
                    </div>
                    <div className='mt-4 text-center'>
                        <button type="submit" className="purpleButton">
                            Submit
                        </button>
                    </div>
                </form>
                <IonToast
                    isOpen={showToast}
                    message="Message sent successfully!"
                    duration={2000}
                    onDidDismiss={() => setShowToast(false)}
                />
            </IonCard>
            <Footer />
        </IonContent>
    );
};

export default ContactUs;
